import jsPDF from 'jspdf';
import { CartelaBingo } from '../eventoAdicionalData';
import { gerarCartelaBingoCanvas } from './bingoCartelaImage';

/* A4 retrato, 1 cartela por folha (bem grande, fácil de recortar e de ler no bingo).
   A proporção da cartela (1024x1423) é mantida para não distorcer os números nem a foto. */
const PAGE_W = 210;
const PAGE_H = 297;
const MARGIN_Y = 10;
const CARD_H = PAGE_H - MARGIN_Y * 2;
const CARD_W = CARD_H * (1024 / 1423);
const MARGIN_X = (PAGE_W - CARD_W) / 2;
/** Cada cartela é renderizada em alta resolução; lotes pequenos mantêm a aba respondendo. */
const LOTE = 3;

const canvasParaJpeg = (canvas: HTMLCanvasElement | null) => {
  if (!canvas) return null;
  try {
    return canvas.toDataURL('image/jpeg', 0.88);
  } catch {
    return null;
  }
};

const desenharGuiaCorte = (doc: jsPDF, x: number, y: number) => {
  doc.setDrawColor(190);
  doc.setLineWidth(0.1);
  doc.setLineDashPattern([1, 1], 0);
  doc.rect(x, y, CARD_W, CARD_H, 'S');
};

export const gerarPdfCartelasBingo = async (
  cartelas: CartelaBingo[],
  onProgress?: (feito: number, total: number) => void
): Promise<jsPDF> => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });

  for (let inicio = 0; inicio < cartelas.length; inicio += LOTE) {
    const lote = cartelas.slice(inicio, inicio + LOTE);
    const geradas = await Promise.all(
      lote.map(async (cartela) => canvasParaJpeg(await gerarCartelaBingoCanvas(cartela)))
    );

    for (let indice = 0; indice < geradas.length; indice += 1) {
      const jpeg = geradas[indice];
      if (inicio + indice > 0) doc.addPage();

      if (jpeg) doc.addImage(jpeg, 'JPEG', MARGIN_X, MARGIN_Y, CARD_W, CARD_H);
      desenharGuiaCorte(doc, MARGIN_X, MARGIN_Y);

      onProgress?.(inicio + indice + 1, cartelas.length);
    }
  }

  return doc;
};

export const baixarPdfCartelasBingo = async (
  cartelas: CartelaBingo[],
  onProgress?: (feito: number, total: number) => void
) => {
  const doc = await gerarPdfCartelasBingo(cartelas, onProgress);
  const data = new Date().toISOString().slice(0, 10);
  doc.save(`cartelas-bingo-${data}.pdf`);
};
